import { request } from "apis/base";
import { ReceiptBulkCreateBody, ReceiptCreateBody } from "constants/types/receipt";

interface ReviewBody {
  reviewNote: string;
}

export const receiptApi = {
  getById: (id: string) => {
    return request({ url: `/payment-journal/${id}`, method: "GET" });
  },

  create: (data: ReceiptCreateBody) => {
    return request({ url: "/payment-journal", method: "POST", data });
  },

  createMany: (data: ReceiptBulkCreateBody) => {
    return request({ url: "/payment-journal/bulk", method: "POST", data });
  },

  approve: (id: string, data: ReviewBody) => {
    return request({
      url: `/payment-journal/${id}/approve`,
      method: "PATCH",
      data,
    });
  },

  reject: (id: string, data: ReviewBody) => {
    return request({
      url: `/payment-journal/${id}/reject`,
      method: "PATCH",
      data,
    });
  },

  reverse: (id: string) => {
    return request({ url: `/payment-journal/${id}/reverse`, method: "DELETE" });
  },
};
